
const SET_TOKEN = (state, payload) => {
  state.token = payload
}

export default {
  SET_TOKEN
}



// WEBPACK FOOTER //
// ./src/store/modules/memed/mutations.js